import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let item_id = useDataValue({
    context: 'item',
    path: 'id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next = next.includes(item_id)
        ? next.filter(i => i !== item_id)
        : next.concat(item_id)
    })
  }
}
